import { Link } from 'react-router-dom'
import { Avatar } from '@/components/ui/Avatar'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import { TypeClientBadge } from './TypeClientBadge'
import { Eye, MoreHorizontal, Mail, Phone } from 'lucide-react'
import { formatDate } from '@/lib/utils'
import type { Client } from '@/types/client'

interface ClientRowProps {
  client: Client
}

export function ClientRow({ client }: ClientRowProps) {
  return (
    <tr className="hover:bg-beige-50 transition-colors">
      <td className="px-4 py-3">
        <div className="flex items-center gap-3">
          <Avatar src={client.avatar_url} name={client.full_name} size="md" />
          <div>
            <p className="font-medium text-brown-900">{client.full_name}</p>
            <p className="text-sm text-brown-500">{client.email}</p>
          </div>
        </div>
      </td>
      <td className="px-4 py-3">
        <div className="flex items-center text-sm text-brown-600">
          <Mail className="w-4 h-4 mr-2 text-brown-400" />
          {client.email}
        </div>
      </td>
      <td className="px-4 py-3">
        {client.phone ? (
          <div className="flex items-center text-sm text-brown-600">
            <Phone className="w-4 h-4 mr-2 text-brown-400" />
            {client.phone}
          </div>
        ) : (
          <span className="text-sm text-brown-400">-</span>
        )}
      </td>
      <td className="px-4 py-3">
        <TypeClientBadge type={client.type_client} size="sm" />
      </td>
      <td className="px-4 py-3">
        <span className="text-brown-600 text-sm">
          {client.company || '-'}
        </span>
      </td>
      <td className="px-4 py-3">
        {client.projects_count !== undefined && client.projects_count > 0 ? (
          <span className="text-brown-600 text-sm">
            {client.projects_count} projet(s)
          </span>
        ) : (
          <span className="text-brown-400 text-sm">0 projet</span>
        )}
      </td>
      <td className="px-4 py-3">
        {client.factures_impayees !== undefined && client.factures_impayees > 0 && (
          <Badge variant="red" size="sm">
            {client.factures_impayees} impayee(s)
          </Badge>
        )}
      </td>
      <td className="px-4 py-3">
        <span className="text-sm text-brown-500">
          {formatDate(client.created_at)}
        </span>
      </td>
      <td className="px-4 py-3">
        <div className="flex gap-1">
          <Link to={`/clients/${client.id}`}>
            <Button variant="ghost" size="sm">
              <Eye className="w-4 h-4" />
            </Button>
          </Link>
          <Button variant="ghost" size="sm">
            <MoreHorizontal className="w-4 h-4" />
          </Button>
        </div>
      </td>
    </tr>
  )
}
